export function NotFound() {
  return <div>Sowwy, I might've had a fuckie wuckie. No page here!</div>;
}
